module.exports = __webpack_public_path__ + "static/media/FoilingIcon.aca8b40c.png";